import React, { useState } from 'react';

import { YatImageDisplay } from '@pkg/components';
import { copyToClipboard } from '@pkg/utils';

import config from '@app/config';

import './_UsersYat.scss';

interface UsersYatProps {
    yat: string;
}
const { publicUrl } = config;

const UsersYat = ({ yat }: UsersYatProps) => {
    const [showCopied, setShowCopied] = useState<boolean>(false);

    const yatCopied = (): void => {
        setShowCopied(true);
        setTimeout(function () {
            setShowCopied(false);
        }, 800);
    };

    return (
        <div
            onClick={(e) => {
                e.stopPropagation();
                copyToClipboard(`${window.location.protocol}//${publicUrl}/${yat}`, yatCopied);
            }}
            className="users-yat"
        >
            <YatImageDisplay emojiID={yat} imageHeight={75} isLarge={true} />
            {showCopied && (
                <img alt="copy icon" className="users-yat__copy-success" src="/assets/icons/copy-link-icon.svg" />
            )}
        </div>
    );
};

export default UsersYat;
